@if ((isLoading$ | async) === true) {
	<uc-university-skeleton [header]="false" [banner]="true" />
}
@if (university$ | async; as university) {
	<main
		class="relative sm:mt-0"
		ucUniProfileGAEvent
		ucUniImpression
		[eventTypes]="['view']"
		[uniId]="university.id"
		[uniName]="university.name"
		[ugSearchOrderPosition]="university.order"
		[cleSearchOrderPosition]="null"
		[product]="product"
		[regionFilter]="university.address.region"
		profileTab="Open-days"
	>
		@if ((isLoading$ | async) === false) {
			<uc-university-slider
				[uniGallery]="uniGallery"
				[product]="product"
				[isFeaturedGallery]="isFeatured"
				[uniSliderCopy]="uniSliderCopy()"
				[id]="university.id"
				[saved]="university.saved"
				[delta]="1"
				tab="open-days"
				[ugSearchOrderPosition]="university.order"
				[cleSearchOrderPosition]="null"
				[uniName]="university.name"
			>
				<uc-university-header-title
					headerTitle
					[name]="university.name"
					[paidFeatures]="university.paid_features"
					[subdirectory]="product"
					[product]="product"
					[slug]="university.slug"
					[uniId]="university.id"
				/>

				<uc-cta-open-days-btns
					[isFeatured]="isFeatured"
					[featuredEvent]="featuredEvent()"
					[uniId]="university.id"
					[uniSlug]="uniSlug"
					[product]="product"
					[uniName]="university.name"
					[externalUrl]="externalUrl()"
					[externalEventsUrl]="externalEventsUrl()"
					componentName="Event Empty State"
					[ugSearchOrderPosition]="university.order"
					[privacyPolicyUrl]="university.privacy_policy_url"
				/>
			</uc-university-slider>

			@if (isFeatured && (events$ | async)) {
				<div class="container">
					@if (
						undergraduateEvents.length > 0 || postgraduateEvents.length > 0
					) {
						@if (undergraduateEvents.length > 0) {
							<div class="pb-4 border-b sm:pb-16">
								<div class="mt-12">
									<uc-heading
										headingTitle="{{ university.name }} Open Days"
									/>
								</div>
								<div class="mb-2">
									<uc-open-days-recommended-events-wrapper
										[events]="recommendedEvents"
										[componentName]="componentName"
										[uniName]="university.name"
										[uniId]="university.id"
										[uniSlug]="uniSlug"
										[ugSearchOrderPosition]="university.order"
										[privacyPolicyUrl]="university.privacy_policy_url"
									/>
								</div>
								<div class="grid divide-y sm:gap-8 sm:divide-y-0">
									@for (event of undergraduateEvents; track event) {
										<uc-event-card
											[uniName]="university.name"
											[uniLogo]="university.logo"
											[slug]="university.slug"
											[uniId]="university.id"
											[id]="event.id"
											[date]="event.date"
											[description]="event.description"
											[subtitle]="event.subtitle"
											[externalUrl]="event.external_url"
											product="undergraduate"
											[componentName]="componentName"
											[ugSearchOrderPosition]="university.order"
											[privacyPolicyUrl]="
												university.privacy_policy_url
											"
											[eventType]="event.type"
										/>
									}
								</div>
							</div>
						}
						@if (postgraduateEvents.length > 0) {
							<div class="pb-4 border-b sm:pb-16">
								<div class="pt-8 mt-4 -mb-4 sm:-mb-0 sm:pt-12 sm:mt-0">
									<uc-heading
										headingTitle="{{
											university.name
										}} Postgraduate Open Days"
									/>
								</div>
								<div class="grid divide-y sm:gap-8 sm:divide-y-0">
									@for (event of postgraduateEvents; track event) {
										<uc-event-card
											[uniName]="university.name"
											[uniLogo]="university.logo"
											[slug]="university.slug"
											[uniId]="university.id"
											[id]="event.id"
											[date]="event.date"
											[description]="event.description"
											[subtitle]="event.subtitle"
											[externalUrl]="event.external_url"
											product="postgraduate"
											[componentName]="componentName"
											[ugSearchOrderPosition]="university.order"
											[privacyPolicyUrl]="
												university.privacy_policy_url
											"
											[eventType]="event.type"
										/>
									}
								</div>
							</div>
						}
					} @else {
						<div class="py-8 border-b sm:py-12">
							<uc-no-open-days
								[uniId]="university.id"
								[uniName]="university.name"
								product="undergraduate"
								[isFeatured]="true"
								[externalUrl]="externalEventsUrl()"
								[ugSearchOrderPosition]="university.order"
								[privacyPolicyUrl]="university.privacy_policy_url"
							></uc-no-open-days>
						</div>
					}
				</div>
			}
			<uc-our-location
				[universityName]="university.name"
				[googleMap]="university.address.maps"
				[address1]="universityAddress[0]"
				[address2]="universityAddress[1]"
				[postcode]="university.address.postcode"
				[country]="university.address.region"
				headerPrefix="Finding your way to "
				headerSuffix=""
			/>
			@if (!isFeatured) {
				@if (!isFeatured) {
					<div class="container">
						<div class="pb-8 border-t lg:pb-0">
							<uc-recommended-unis-grid
								product="undergraduate"
								componentName="Open Days Recommended Universities"
							/>
						</div>
					</div>
				}
			}
		}
	</main>
}
